module.exports = __webpack_public_path__ + "img/case-logo-7.315eb372.png";